const DEFAULT_ASPECT_RATIO = '3:2';

const IMAGE_TYPE = {
  FEATURED_BOATS_HOMEPAGE: { width: 620 }
};

const RESIZER_PARAMETERS = {
  ASPECT_RATIO: 'ratio',
  EXACT: 'exact',
  FORMAT: 'format',
  HEIGHT: 'h',
  TIMESTAMP: 't',
  WIDTH: 'w'
};

const addImageResizerParams = (url, imageType, modified, format = '') => {
  if (!url || !imageType) {
    return url;
  }

  const timestamp = modified ? new Date(modified).getTime() : null;

  const queryParams = new URLSearchParams();
  queryParams.set(RESIZER_PARAMETERS.ASPECT_RATIO, DEFAULT_ASPECT_RATIO);
  queryParams.append(RESIZER_PARAMETERS.EXACT, '');

  if (imageType.height) { queryParams.append(RESIZER_PARAMETERS.HEIGHT, imageType.height); }
  if (imageType.width) { queryParams.append(RESIZER_PARAMETERS.WIDTH, imageType.width); }
  if (format) { queryParams.append(RESIZER_PARAMETERS.FORMAT, format); }
  if (timestamp) { queryParams.append(RESIZER_PARAMETERS.TIMESTAMP, timestamp); }

  return `${url.split('?')[0]}?${queryParams.toString()}`;
};

export {
  IMAGE_TYPE,
  addImageResizerParams
};
